var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrendIncreaseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffffb3",
    d: "M3.415 3.36c-.021-.19.149-.36.36-.36h8.871c.212 0 .36.149.36.36v8.87c0 .213-.17.383-.36.361l-.828.022c-.212 0-.382-.17-.36-.361l-.022-6.6L4.2 12.89a.347.347 0 0 1-.509 0l-.594-.595a.365.365 0 0 1 0-.509l7.236-7.236H3.755c-.191.021-.361-.148-.361-.36l.021-.828Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrendIncreaseWhite);
export default __webpack_public_path__ + "static/media/icon-trend-increase-white.144bc52859f081ead5817a2cd35eb770.svg";
export { ForwardRef as ReactComponent };